/* Pura Belle Releasit GPS repair v3
   Runs only after browser geolocation permission. Never submits orders,
   never fills phone/name/house number. Exact delivery address must be verified.
*/
(function(){
'use strict';
var CONFIG={geoapifyKey:''};
try{
  var tag=document.getElementById('pb-geocoder-settings');
  if(tag)CONFIG=JSON.parse(tag.textContent)||CONFIG;
}catch(e){}
var SESSION_PROMPT='pb-releasit-gps-attempt-v3';
var SESSION_DATA='pb-releasit-location-v3';
var current=null;
var requesting=false;
var lastReleasitClick=0;
var scanPending=false;
var labelCache=[];
function getSession(k){try{return sessionStorage.getItem(k)}catch(e){return null}}
function setSession(k,v){try{sessionStorage.setItem(k,v)}catch(e){}}
function normalize(s){return String(s||'').trim()}
function el(id){return document.getElementById(id)}
function status(text){
  var p=el('pb-gps-status');if(p)p.textContent=text;
}
function suggestion(info){
  if(!info)return '';
  var parts=[];
  if(verifiedStreet(info))parts.push(info.street);
  if(info.area && normalize(info.area).toLowerCase()!==normalize(info.city).toLowerCase())parts.push(info.area);
  if(info.city)parts.push(info.city);
  if(info.province && normalize(info.province).toLowerCase()!==normalize(info.city).toLowerCase())parts.push(info.province);
  return parts.join(', ');
}
function verifiedStreet(info){
  return !!(info&&info.source==='Geoapify'&&normalize(info.street)&&
     Number(info.streetConfidence)>=0.68&&Number(info.accuracy)>0&&Number(info.accuracy)<=100&&
     (!Number.isFinite(Number(info.distance))||Number(info.distance)<=160));
}
function showSuggestion(){
  var root=el('pb-gps-suggestion'),text=el('pb-gps-suggestion-text');
  if(!root||!text||!current)return;
  var s=suggestion(current);
  if(!s){root.hidden=true;return;}
  text.textContent=s;
  root.hidden=false;
}
function fieldName(node){
  var a=[node.getAttribute('name'),node.id,node.getAttribute('placeholder'),node.getAttribute('aria-label'),node.getAttribute('data-field'),node.getAttribute('autocomplete')];
  if(node.labels)Array.prototype.forEach.call(node.labels,function(lbl){a.push(lbl.textContent.slice(0,120))});
  var wrapper=node.closest('label');
  if(wrapper&&wrapper.textContent.length<140)a.push(wrapper.textContent);
  var parent=node.parentElement;
  if(parent){
    var siblingLabel=parent.querySelector('label');
    if(siblingLabel&&siblingLabel.textContent.length<110)a.push(siblingLabel.textContent);
  }
  return a.filter(Boolean).join(' ').toLowerCase();
}
function looksReleasit(node){
  try{
    if(node.closest('[id*="rsi-cod"],[class*="rsi-cod"],[id*="_rsi"],[class*="_rsi"],[id*="releasit"],[class*="releasit"]'))return true;
    // Newer Releasit versions can render a detached modal outside the product section.
    if(Date.now()-lastReleasitClick>60000)return false;
    var modal=node.closest('[role="dialog"],[aria-modal="true"],[class*="modal"],[class*="popup"]');
    if(!modal || !modal.getClientRects().length)return false;
    var fields=Array.prototype.slice.call(modal.querySelectorAll('input,textarea,select'),0,35);
    var labels=fields.map(fieldName).join(' ');
    return /(?:phone|mobile|telephone|contact|نمبر)/i.test(labels) &&
           /(?:address|city|street|area|location|پتہ|شہر)/i.test(labels);
  }catch(e){return false;}
}
function kindOfField(input){
  var name=fieldName(input);
  if(/(?:email|phone|mobile|name|first.name|last.name|apartment|house.number|building.number|flat.number|zip|postcode|postal)/i.test(name))return '';
  if(/(?:\b(city|town|shehar|locality)\b|شہر)/i.test(name))return 'city';
  if(/(?:\b(province|region|state|subdivision)\b|صوبہ)/i.test(name))return 'province';
  if(/(?:\b(area|neighbou?rhood|mohalla|village|district|suburb|quarter)\b|علاقہ|محلہ)/i.test(name))return 'area';
  if(/(?:\b(street|road|gali|lane|avenue)\b|گلی|سڑک)/i.test(name))return 'street';
  if(/(?:\b(address|delivery.address|shipping.address|address1|address.line.1)\b|پتہ)/i.test(name))return 'address';
  return '';
}
function smartSet(input,value){
  value=normalize(value);
  if(!value || input.disabled ||input.readOnly ||input.type==='hidden' ||input.type==='checkbox'||input.type==='radio')return false;
  var before=normalize(input.value);
  var prior=input.getAttribute('data-pb-gps-fill');
  if(before && before!==prior)return false; // Never overwrite what the customer typed.
  if(input.tagName==='SELECT'){
    var options=Array.prototype.slice.call(input.options);
    var found=options.find(function(o){return normalize(o.value).toLowerCase()===value.toLowerCase()||normalize(o.textContent).toLowerCase()===value.toLowerCase()});
    if(!found)return false;
    value=found.value;
  }
  if(before===value)return false;
  var desc=Object.getOwnPropertyDescriptor(input.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:input.tagName==='SELECT'?HTMLSelectElement.prototype:HTMLInputElement.prototype,'value');
  if(desc&&desc.set)desc.set.call(input,value);else input.value=value;
  input.setAttribute('data-pb-gps-fill',value);
  input.dispatchEvent(new Event('input',{bubbles:true}));
  input.dispatchEvent(new Event('change',{bubbles:true}));
  return true;
}
function fillForm(){
  if(!current)return;
  var count=0;
  document.querySelectorAll('input,textarea,select').forEach(function(input){
    if(!looksReleasit(input))return;
    var kind=kindOfField(input),v='';
    if(kind==='city')v=current.city;
    if(kind==='province')v=current.province;
    if(kind==='area')v=current.area;
    if(kind==='street'&&verifiedStreet(current))v=current.street;
    if(kind==='address'&&verifiedStreet(current))v=suggestion(current);
    if(v && smartSet(input,v))count++;
  });
  if(count>0){
    status('Location suggestions filled in the Releasit form. Please check the street and add your exact house/landmark.');
  }
}
function scheduleScan(){
  if(scanPending)return;
  scanPending=true;
  setTimeout(function(){scanPending=false;fillForm();},260);
}
function withBigDataCloud(c){
  var url='https://api.bigdatacloud.net/data/reverse-geocode-client?latitude='+encodeURIComponent(c.latitude)+'&longitude='+encodeURIComponent(c.longitude)+'&localityLanguage=en';
  return fetch(url,{cache:'no-store'}).then(function(resp){if(!resp.ok)throw Error('Fallback lookup unavailable');return resp.json()}).then(function(x){
    if(x.countryCode&&normalize(x.countryCode).toUpperCase()!=='PK')return null;
    return {city:normalize(x.city||x.locality),area:normalize(x.locality),province:normalize(x.principalSubdivision),
      street:'',streetConfidence:0,distance:null,source:'BigDataCloud',accuracy:c.accuracy||999};
  }).catch(function(){
    return {city:'',area:'',province:'',street:'',streetConfidence:0,distance:null,source:'GPS only',accuracy:c.accuracy||999};
  });
}
function reverseLookup(c){
  var key=normalize(CONFIG.geoapifyKey);
  if(!key)return withBigDataCloud(c);
  var url='https://api.geoapify.com/v1/geocode/reverse?format=json&limit=1&lang=en&lat='
    +encodeURIComponent(c.latitude)+'&lon='+encodeURIComponent(c.longitude)+'&apiKey='+encodeURIComponent(key);
  return fetch(url,{cache:'no-store'}).then(function(resp){
    if(!resp.ok)throw Error('Street lookup unavailable');
    return resp.json();
  }).then(function(r){
    var x=r.results&&r.results[0];
    if(!x)throw Error('No street-level result');
    if(x.country_code&&normalize(x.country_code).toUpperCase()!=='PK')return null;
    return {city:normalize(x.city||x.town||x.village||x.county),
      area:normalize(x.suburb||x.district||x.neighbourhood||x.quarter),
      province:normalize(x.state),street:normalize(x.street),
      streetConfidence:Number(x.rank&&x.rank.confidence_street_level)||0,
      distance:x.distance===undefined?null:Number(x.distance),
      source:'Geoapify',accuracy:c.accuracy||999};
  }).catch(function(){return withBigDataCloud(c);});
}
function received(info){
  if(!info){status('Delivery location is outside Pakistan. Please enter your address manually.');return;}
  current=info;
  setSession(SESSION_DATA,JSON.stringify(info));
  showSuggestion();fillForm();
  if(verifiedStreet(info)){
    status('Nearby street found. Open Buy Now to review the suggested delivery address and add your house number.');
  }else if(info.city||info.area){
    status('Approximate city/area found. Open Buy Now and enter your exact street, house and landmark.');
  }else{
    status('GPS location received, but a readable address was unavailable. Enter delivery details manually.');
  }
}
function askLocation(manual){
  if(requesting || !navigator.geolocation || location.protocol!=='https:'){
    if(manual)status('Your browser cannot request GPS here. Open the theme preview in Chrome/Safari using HTTPS.');
    return;
  }
  if(!manual && getSession(SESSION_PROMPT))return;
  if(!manual)setSession(SESSION_PROMPT,'yes');
  var button=el('pb-gps-location-button');if(button)button.disabled=true;
  requesting=true;
  if(manual)status('Asking your phone for permission. Enable location services if necessary…');
  navigator.geolocation.getCurrentPosition(function(pos){
    status('Location received. Looking for your nearest mapped street…');
    reverseLookup(pos.coords).then(received).catch(function(){
      status('Unable to identify the street. Please enter your address manually.');
    }).finally(function(){requesting=false;if(button)button.disabled=false;});
  },function(err){
    requesting=false;
    if(button)button.disabled=false;
    if(manual){
      status(err && err.code===1 ?
        'Location permission is blocked. Allow location for this site in your browser settings, or enter the address manually.' :
        'GPS location unavailable. Try enabling your phone location, or fill the form manually.');
    }
  },{enableHighAccuracy:true,timeout:18000,maximumAge:0});
}
function onClick(ev){
  var target=ev.target&&ev.target.closest?ev.target.closest('#pb-releasit-buy-now,._rsi-cod-form-gempages-button-hook button,._rsi-cod-form-gempages-button-hook a,[class*="rsi-cod-form"] button'):null;
  if(!target)return;
  lastReleasitClick=Date.now();
  setTimeout(fillForm,250);setTimeout(fillForm,750);setTimeout(fillForm,1800);
}
function init(){
  try{current=JSON.parse(getSession(SESSION_DATA)||'null')}catch(e){}
  var button=el('pb-gps-location-button');
  if(button)button.addEventListener('click',function(){askLocation(true)});
  var copyButton=el('pb-gps-copy');
  if(copyButton)copyButton.addEventListener('click',function(){
    var str=suggestion(current);if(!str)return;
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(str).then(function(){status('Suggested area copied. Paste it into the address field and add your house number.');}).catch(function(){window.prompt('Copy suggested address:',str);});
    }else{window.prompt('Copy suggested address:',str);}
  });
  document.addEventListener('click',onClick,true);
  if(window.MutationObserver){
    var observer=new MutationObserver(scheduleScan);
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden','aria-expanded']});
  }
  showSuggestion();
  fillForm();
  if(location.protocol==='https:' && window.top===window && document.visibilityState==='visible')askLocation(false);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();